import React from "react";
import { Badge } from "./ui/badge";

const STATUS_COLORS: Record<string, "success" | "warning" | "destructive" | "default"> = {
  // Green: Approved, Installed, Paid, Verified, Active, Resolved, Accepted
  approved: "success",
  installed: "success",
  paid: "success",
  verified: "success",
  active: "success",
  resolved: "success",
  accepted: "success",
  completed: "success",
  
  // Amber: Pending, In Progress, Awaiting / Waiting
  pending: "warning",
  in_progress: "warning",
  waiting_on_agent: "warning",
  action_required: "warning",
  pending_build: "warning",
  processing: "warning",
  invited: "warning",
  invited_to_info_session: "warning",
  attended_info_session: "warning",
  scheduled: "warning",
  started_pre_session: "warning",
  started_post_session: "warning",
  new_lead: "warning",
  draft: "warning",
  held: "warning",
  included: "warning",
  training_in_progress: "warning",
  hoa_approved: "warning",
  new: "warning",

  // Red: Rejected, Cancelled, Suspended, Critical, Expired, No-Show
  rejected: "destructive",
  cancelled: "destructive",
  suspended: "destructive",
  critical: "destructive",
  expired: "destructive",
  no_show: "destructive",
  failed: "destructive",
  declined: "destructive",
  declined_no_show: "destructive",
};

const formatLabel = (status: string) => {
  return status
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export function StatusBadge({ status }: { status: string }) {
  const normalizedStatus = status.toLowerCase();
  const color = STATUS_COLORS[normalizedStatus] || "default";

  // Note: we could customize the badge variants in the UI components 
  // but we map it here to standard classes if the badge doesn't support them natively.
  
  const variantStyles = {
    success: "bg-green-100 text-green-800 hover:bg-green-100 border-green-200",
    warning: "bg-amber-100 text-amber-800 hover:bg-amber-100 border-amber-200",
    destructive: "bg-red-100 text-red-800 hover:bg-red-100 border-red-200",
    default: "bg-gray-100 text-gray-800 hover:bg-gray-100 border-gray-200",
  };

  return (
    <Badge className={variantStyles[color]} variant="outline" data-testid={`status-${status}`}>
      {formatLabel(status)}
    </Badge>
  );
}
